import React, { useCallback } from 'react'
import TransactionConfirmationModal, { TransactionErrorContent } from 'components/TransactionConfirmationModal'
import { useTranslation } from 'contexts/Localization'
import { InjectedModalProps } from '@pancakeswap/uikit'

interface ReleaseBridgeModalProps {
  attemptingTxn: boolean
  txHash?: string
  swapErrorMessage?: string
  tokenId?: string
  collectionName?: string
  customOnDismiss?: () => void
  onRetry?: () => void
}

export function ReleaseBridgeModal({
  onDismiss,
  onRetry,
  customOnDismiss,
  swapErrorMessage,
  attemptingTxn,
  txHash,
  tokenId,
  collectionName,
}: ReleaseBridgeModalProps & InjectedModalProps) {
  const { t } = useTranslation()
  let pendingText = `Releasing token ${tokenId}`
  if ((collectionName || '').length > 0) {
    pendingText = `${pendingText} from collection ${collectionName}`
  }

  const closeModal = useCallback(() => {
    onDismiss()
    if (customOnDismiss) customOnDismiss()
  }, [onDismiss, customOnDismiss])

  const confirmationContent = useCallback(
    () =>
      swapErrorMessage ? (
        <TransactionErrorContent onDismiss={closeModal} message={swapErrorMessage} onRetry={onRetry} />
      ) : null,
    [closeModal, onRetry, swapErrorMessage],
  )

  return (
    <TransactionConfirmationModal
      title={t('Releasing token on bridge')}
      onDismiss={closeModal}
      customOnDismiss={customOnDismiss}
      attemptingTxn={attemptingTxn}
      hash={txHash}
      content={confirmationContent}
      pendingText={pendingText}
    />
  )
}
